import { ValueGetterParams } from "ag-grid-community";
import { calculateFilterTreeFiltersCount } from "@/components/pages/common/filters-tree/utils/helpers/calculateFilterTreeFiltersCount";
import { addIdsToFilterTreeItems } from "@/components/pages/common/filters-tree/utils/helpers/ids-manipulations/addIdsToFilterTreeItems";
import { BudgetWithIntegrations } from "@/store/budgets/utils/types/common";

export const budgetNameValueGetter = ({
  data,
}: ValueGetterParams<BudgetWithIntegrations>) =>
  `${data?.name} ${data?.filter_tree ? calculateFilterTreeFiltersCount(addIdsToFilterTreeItems(data?.filter_tree)) : ""}`;
